import { render, staticRenderFns } from "./SignDocument.vue?vue&type=template&id=ecdb2854&scoped=true&"
import script from "./SignDocument.vue?vue&type=script&lang=js&"
export * from "./SignDocument.vue?vue&type=script&lang=js&"
import style0 from "./SignDocument.vue?vue&type=style&index=0&id=ecdb2854&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecdb2854",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ecdb2854')) {
      api.createRecord('ecdb2854', component.options)
    } else {
      api.reload('ecdb2854', component.options)
    }
    module.hot.accept("./SignDocument.vue?vue&type=template&id=ecdb2854&scoped=true&", function () {
      api.rerender('ecdb2854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Packages/FIlesPreviewer/components/Tools/SignDocument.vue"
export default component.exports